import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    availableRoutes: []
};
function routeResource(data) {
    return {
        name: data.name,
        available: data.available
    };
}
export var RoutesReducer = createSlice({
    name: 'routes',
    initialState: initialState,
    reducers: {
        setAvailableRoutes: function setAvailableRoutes(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function callback(item, index) {
                data[index] = routeResource(item);
            });
            state.availableRoutes = data;
        }
    }
});
var setAvailableRoutes = RoutesReducer.actions.setAvailableRoutes;
export { setAvailableRoutes };
export default RoutesReducer.reducer;
